module.exports = __webpack_public_path__ + "7c2b51f3353a5f82f385428af9757e35.svg";